import { useQuery } from "@tanstack/react-query";
import { ShieldCheck } from "@phosphor-icons/react";
import { useApi } from "@/lib/api";

const Stat = ({ label, value, testid, accent }) => (
  <div className="rounded-xl border border-[#2A2A2A] bg-[#121212] p-5">
    <p className="font-mono text-[11px] text-[#A3A3A3]">{label}</p>
    <p data-testid={testid} className={`mt-2 font-mono text-3xl ${accent || "text-white"}`}>{value}</p>
  </div>
);

export default function AdminSaveOffers() {
  const api = useApi();
  const { data, error, isLoading } = useQuery({ queryKey: ["admin-save-offers"], queryFn: () => api.get("/admin/save-offers"), retry: false });
  if (isLoading) return <p className="text-sm text-[#A3A3A3]">Loading…</p>;
  if (error) return <p data-testid="admin-save-offers-denied" className="text-sm text-[#A3A3A3]">This page is only available to admins.</p>;
  return (
    <div data-testid="admin-save-offers-page" className="max-w-4xl">
      <p className="font-mono text-xs text-[#A3A3A3] flex items-center gap-2"><ShieldCheck className="text-[#00FF9D]" /> ADMIN · ALL TIME</p>
      <h1 className="font-display text-3xl md:text-4xl font-semibold mt-1">Save offers</h1>
      <p className="mt-3 text-sm text-[#A3A3A3]">Subscribers who opened Cancel and saw the one-month-free offer. Counting started when the offer went live.</p>
      <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
        <Stat label="OFFERED" value={data.offered} testid="save-offers-offered" />
        <Stat label="STAYED" value={data.stayed} testid="save-offers-stayed" accent="text-[#00FF9D]" />
        <Stat label="STILL CANCELLED" value={data.cancelled} testid="save-offers-cancelled" accent="text-[#FF5C7A]" />
        <Stat label="STAY RATE" value={data.stay_rate == null ? "—" : `${data.stay_rate}%`} testid="save-offers-rate" />
      </div>
      {data.deciding > 0 && (
        <p data-testid="save-offers-deciding" className="mt-4 text-xs text-[#A3A3A3]">{data.deciding} saw the offer but closed the window without choosing. They're not in the stay rate.</p>
      )}
    </div>
  );
}
